import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { mediaService } from '../services/media.service';
import { MediaType } from '../types/media.types';

export const useUploadMedia = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (file: File) => mediaService.uploadMedia(file),
    onSuccess: () => {
      // Invalidate and refetch media queries
      queryClient.invalidateQueries({ queryKey: ['userMedia'] });
      queryClient.invalidateQueries({ queryKey: ['storageInfo'] });
    },
  });
};

export const useUserMedia = (type?: MediaType) => {
  return useQuery({
    queryKey: ['userMedia', type],
    queryFn: () => mediaService.getUserMedia(type),
    select: (response) => response.data,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useMediaById = (mediaId: string | null) => {
  return useQuery({
    queryKey: ['media', mediaId],
    queryFn: () => mediaService.getMediaById(mediaId!),
    select: (response) => response.data,
    enabled: !!mediaId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useDeleteMedia = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (mediaId: string) => mediaService.deleteMedia(mediaId),
    onSuccess: () => {
      // Invalidate and refetch media queries
      queryClient.invalidateQueries({ queryKey: ['userMedia'] });
      queryClient.invalidateQueries({ queryKey: ['storageInfo'] });
    },
  });
};

export const useStorageInfo = () => {
  return useQuery({
    queryKey: ['storageInfo'],
    queryFn: () => mediaService.getStorageInfo(),
    select: (response) => response.data,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};